<template>
	<section>
		<div v-if="showParentView('page-company')">
			<header-page
				name="companies"
				:title="$route.meta.title"
			/>
			<v-layout pl-5 pt-3>
				<v-flex xs2 mt-3>
					<v-select
						box
						background-color="white"
						class="body-1"
						hide-details
						label="Planes"
						item-text="name"
						item-value="id"
						:items="plans"
						v-model="params.typePlan"
					></v-select>
				</v-flex>
				<v-flex xs2 ml-3>
					<date-component
						label="Fecha Inicio"
						:date-formatted="params.startDate"
						model="startDate"
						@input="setDate({ model: 'startDate', value: $event })"
					/>
				</v-flex>
				<v-flex xs2 ml-3>
					<date-component
						label="Fecha Final"
						:date-formatted="params.endDate"
						:max-date="maxDate"
						model="endDate"
						@input="setDate({ model: 'endDate', value: $event })"
					/>
				</v-flex>
			</v-layout>
			<company-list
				:codeProject="codeProject"
				:columns="columns"
				:current-page="currentPage"
				:rows="rows"
				:plans="plans"
				:last-page="lastPage"
				:check-all="checkAll"
				@on-selected-all="onSelected"
				@row-is-selected="rowIsSelected"
				@change-page="changePage"
				@on-search="onSearch($event)"
			/>
			<quick-actions
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
			<action-sidebar
				:title="action.title"
				:width="action.width"
				:value="action.value"
				@close-modal="closeModal"
			>
				<company-sales
					v-if="action.code === 'VIS'"
					:data-selected="dataSelected"
					@close-modal="closeModal"
				/>
			</action-sidebar>
		</div>
		<router-view></router-view>
	</section>
</template>

<script>
	import quickActions from '@/components/shared/quick-actions';
	import companyList from '@/components/companies/company-list';
	import companySales from '@/components/companies/company-sales';
	import actionSidebar from '@/components/shared/action-sidebar';
	import dateComponent from '@/components/shared/date-component';
	import { format } from 'date-fns';

	function created() {
		if (this.$route.name === 'page-company') {
			this.loadRows(`project/${this.codeProject}/companies`);
			this.loadPlans();
		}
	}

	function changePage(page) {
		this.params.page = page;
		this.currentPage = page;
		this.loadRows(`project/${this.codeProject}/companies`);
	}

	function openModal(value) {
		if (value.code === 'VIS') {
			if (this.dataSelected.length === 0) {
				this.showNotification('Debes seleccionar al menos una compañía', 'warning');
				return;
			}
			this.action = {
				code: value.code,
				title: 'Visualizar informacion de ventas',
				width: 700,
				value: true,
			};
		} else if (value.code === 'CC') {
			const codeProject = this.codeProject;
			this.goTo('page-new-company', { params: { codeProject } });
		}
	}

	function data() {
		return {
			actions: [
				{
					id: 1,
					code: 'CC',
					text: 'Crear Compañía',
					img: 'https://goo.su/LvVIPC',
					active: true,
				},
				// {
				// 	id: 2,
				// 	code: 'VIS',
				// 	text: 'Visualizar ventas',
				// 	icon: 'paid',
				// 	active: true,
				// },
			],
			action: {
				title: '',
				code: '',
				width: 0,
				value: false,
			},
			checkAll: false,
			rows: [],
			lastPage: 0,
			plans: [],
			params: {
				typePlan: null,
				startDate: null,
				endDate: null,
			},
			maxDate: new Date().toISOString().split('T')[0],
			columns: [
				{ id: 1, name: 'Nombre', checked: true, visible: true },
				{ id: 2, name: 'Token', checked: true, visible: true },
				{ id: 3, name: 'Razón Social', checked: true, visible: true },
				{ id: 4, name: 'Código', checked: true, visible: true },
				{ id: 5, name: 'Ruc', checked: true, visible: true },
				{ id: 6, name: 'Planes', checked: true, visible: true },
				{ id: 7, name: 'F. Expiración', checked: true, visible: true },
				{ id: 8, name: 'Documentos Relacionados', checked: false, visible: false },
				{ id: 9, name: 'Acciones', checked: true, visible: true, flagVisible: true },
			],
			currentPage: 1,
			dataSelected: [],
		};
	}

	export default {
		name: 'page-company',
		components: {
			companyList,
			quickActions,
			dateComponent,
			actionSidebar,
			companySales,
		},
		created,
		data,
		methods: {
			changePage,
			openModal,
			setDate({ model, value }) {
				this.params[model] = format(value.value, 'YYYY-MM-DD');
			},
			onSearch(search) {
				this.params.search = search ? search.trim() : '';
			},
			async loadRows(url) {
				const query = {
					params: this.params,
				};
				query.headers = {
					Accept: `${process.env.ACCEPT_SERVICE_V2}`,
				};
				const { data: records, headers } = await this.$http.get(url, query);
				this.rows = records.data.map((r) => {
					const newRow = { ...r };
					const plan = this.plans.find((p) => p.id === r.typePlan);
					newRow.namePlan = plan ? plan.name : '-';
					return newRow;
				});
				this.lastPage = Number(headers['x-last-page']);
				this.checkAll = false;
			},
			async loadPlans() {
				const response = await this.$http.get('type-plans');
				this.plans = response.data.data;
			},
			closeModal() {
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
				this.action.width = 0;
			},
			rowIsSelected(row) {
				if (row.isSelected) {
					this.dataSelected.push(row);
				} else {
					const index = this.rows.findIndex(ds => ds.id === row.id);
					if (index > -1) {
						this.dataSelected.splice(index, 1);
					}
				}
				// this.checkAll = this.rows.every(r => r.isSelected);
				this.checkAll = this.rows.length === this.dataSelected.length;
			},
			onSelected(value) {
				this.checkAll = value;
				this.dataSelected = [];
				this.rows = this.rows.map((element) => {
					const newRow = { ...element };
					newRow.isSelected = value;
					if (value) {
						this.dataSelected.push(element);
					}
					return newRow;
				});
			},
		},
		props: {
			codeProject: {
				type: String,
			},
		},
		watch: {
			$route(newVal) {
				if (newVal) {
					if (newVal.name === 'page-company') {
						this.loadRows(`project/${this.codeProject}/companies`);
					}
				}
			},
			params: {
				handler(newVal) {
					if (newVal) {
						this.loadRows(`project/${this.codeProject}/companies`);
					}
				},
				deep: true
			},
		},
	};
</script>


// WEBPACK FOOTER //
// src/pages/companies/page-company.vue